import { 
  createStore, 
  applyMiddleware 
} from 'redux';
import thunk from 'redux-thunk';
import reducerManager from './reducers'
import * as actions from './actions'

import { composeWithDevTools } from 'redux-devtools-extension'

const composeEnhancers = composeWithDevTools({ 
  actions, 
  trace: true, 
  traceLimit: 25
})

const store = createStore (
  reducerManager.reduce,
  composeEnhancers(
    applyMiddleware(thunk)
  )
)

store.reducerManager = reducerManager

export default store